import { c as _c } from "react/compiler-runtime";
import { AFFILIATE_DASHBOARD_API } from 'modules/affiliate-dashboard/api/affiliate-dashboard-api';
import { AffiliateDashboardPromotionInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-promotion-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export const useAffiliateDashboardPromotion = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const {
    user
  } = useUser();
  let t1;
  if ($[1] !== user) {
    t1 = () => {
      if (!user) {
        return;
      }
      return `${AFFILIATE_DASHBOARD_API}/promotion-stats`;
    };
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useSWR(t1, fetcher);
};